import { useEffect, useState } from 'react';
import { SCREENS, TextScreen } from './PaymentTexts';
import MethodEditor, { METHODS } from './MethodEditor';

/** Abas do mercado, na ordem em que o comprador vê as mensagens. */
function tabsOf(market) {
    const screen = (key) => ({ key, label: SCREENS[market][key].title, screen: key });
    if (market === 'usd') return Object.keys(SCREENS.usd).map(screen);
    return [
        screen('currency'),
        ...METHODS.map((m) => ({ key: m.key, label: `${m.label} · ${m.currency}`, flag: m.flag, method: m })),
        screen('secure'),
        screen('loading'),
    ];
}

/**
 * Todas as mensagens de pagamento de um mercado, uma aba por vez: cresce com
 * novas formas de pagamento sem virar uma tela enorme. `focus` abre uma aba
 * (ex.: a do SPEI quando a mensagem dele foi recusada ao salvar).
 */
export default function MessagesEditor({ market, templates, templateDefaults, onTemplatesChange,
    texts, textDefaults, onTextsChange, buttonsOff = [], onButtonsOffChange, focus = null }) {
    const tabs = tabsOf(market);
    const [open, setOpen] = useState(focus || tabs[0].key);
    useEffect(() => { if (focus) setOpen(focus); }, [focus]);
    const current = tabs.find((t) => t.key === open) || tabs[0];

    return (
        <section className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-4">
            <div role="tablist" aria-label="Mensagens" className="flex flex-wrap gap-1 mb-4">
                {tabs.map((t) => {
                    const active = t.key === current.key;
                    return (
                        <button key={t.key} type="button" role="tab" aria-selected={active}
                            onClick={() => setOpen(t.key)}
                            className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-lg border text-xs font-medium transition-colors ${
                                active ? 'border-teal-500/60 bg-teal-500/15 text-white' : 'border-white/10 text-white/55 hover:text-white hover:bg-white/[0.05]'
                            }`}>
                            {t.flag && <img alt="" className="w-4 h-3 object-cover rounded-[2px]" src={`https://flagcdn.com/w20/${t.flag}.png`} />}
                            {t.label}
                        </button>
                    );
                })}
            </div>

            <div role="tabpanel" aria-label={current.label}>
                {current.method ? (
                    <MethodEditor
                        method={current.method}
                        template={templates[current.key]}
                        defaultTemplate={templateDefaults[current.key]}
                        onTemplateChange={(text) => onTemplatesChange({ ...templates, [current.key]: text })}
                        texts={texts} textDefaults={textDefaults} onTextsChange={onTextsChange}
                        buttonsOff={buttonsOff} onButtonsOffChange={onButtonsOffChange}
                    />
                ) : (
                    <TextScreen market={market} screen={current.screen} value={texts} defaults={textDefaults} onChange={onTextsChange} />
                )}
            </div>
        </section>
    );
}
